const respirationUrgent = "Respiration (Urgent)";
const respirationNotUrgent = "Respiration (Not Urgent)";

export const labels = {
    respirationLowError: {
        value: "Respiration - Low Error",
        replacement: respirationUrgent,
        tooltip: "Respiration"
    },
    respirationHighError: {
        value: "Respiration - High Error",
        replacement: respirationUrgent,
        tooltip: "Respiration"
    },
    respirationLowWarn: {
        value: "Respiration - Low Warn",
        replacement: respirationNotUrgent,
        tooltip: "Respiration"
    },
    respirationHighWarn: {
        value: "Respiration - High Warn",
        replacement: respirationNotUrgent,
        tooltip: "Respiration"
    },
    respiration: {
        value: "Respiration"
    },
    movement: {
        value: "Movement"
    },
    normalRangeLowerBound: {
        value: "Normal Range Lower Bound"
    },
    normalRangeUpperBound: {
        value: "Normal Range Upper Bound"
    },
    normalRange: {
        value: "Normal Range"
    },
    outOfRange: {
        value: "Out of Range"
    }
};

export const labelBlackList = [
    labels.normalRangeUpperBound.value,
    labels.normalRangeLowerBound.value,
    labels.normalRange.value,
    labels.outOfRange.value
];

export const labelsOrder = {
    [labels.respiration.value]: 1,
    [respirationUrgent]: 3,
    [respirationNotUrgent]: 2,
    [labels.movement.value]: 4
};
